import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-button-action-dialog',
  standalone: true,
  imports: [MatIconModule,MatButtonModule],
  templateUrl: './button-action-dialog.component.html',
  styleUrls: ['./button-action-dialog.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonActionDialogComponent {
@Input() action!: string
@Input() disabled : boolean = false

 }
